import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Estudiante, fetchGetEstudianteName } from '../../api/estudiante';

export const fetchEstudianteData = createAsyncThunk('estudiante/fetchEstudianteData', async (estudianteKey: string) => {
	const response = await fetchGetEstudianteName(estudianteKey);
	return response;
});

const initialState: Estudiante = {} as Estudiante;

const datosBaseEstudianteStateSlice = createSlice({
	name: 'datosBaseEstudianteState',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(fetchEstudianteData.fulfilled, (state, action) => {
			return action.payload;
		});
	}
});

export default datosBaseEstudianteStateSlice.reducer;
